const firebase = require('firebase');

const firebaseConfig = {
  apiKey: "AIzaSyAEJgt_Ort7jNzkaNt25EfqRyoF4jc0bDI",
  authDomain: "mytimetracker-93578.firebaseapp.com",
  databaseURL: "https://mytimetracker-93578.firebaseio.com",
  projectId: "mytimetracker-93578",
  storageBucket: "mytimetracker-93578.appspot.com",
  messagingSenderId: "156734662726",
  appId: "1:156734662726:web:8b8447eaeba378e2244247",
  measurementId: "G-S0JLW41Z8G"
};

  var app = firebase.initializeApp(firebaseConfig);

  export default app;